var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53789 6.18673C1.53789 4.62568 2.15802 3.12856 3.26185 2.02474C4.36568 0.920906 5.86279 0.300781 7.42384 0.300781C8.98489 0.300781 10.482 0.920906 11.5858 2.02474C12.6897 3.12856 13.3098 4.62568 13.3098 6.18673V9.64251L14.7813 11.8497V15.0156H10.653C10.4857 15.7468 10.0751 16.3994 9.4886 16.8669C8.90206 17.3343 8.17423 17.5889 7.42421 17.5889C6.67418 17.5889 5.94636 17.3343 5.35982 16.8669C4.77328 16.3994 4.36275 15.7468 4.1954 15.0156H0.0664062V11.8497L1.53789 9.64251V6.18673ZM5.73752 15.0156C5.88053 15.344 6.11628 15.6234 6.41583 15.8197C6.71539 16.0159 7.06572 16.1205 7.42384 16.1205C7.78196 16.1205 8.13229 16.0159 8.43185 15.8197C8.7314 15.6234 8.96715 15.344 9.11016 15.0156H5.73752ZM7.42384 1.77227C6.25305 1.77227 5.13022 2.23736 4.30235 3.06523C3.47447 3.8931 3.00938 5.01594 3.00938 6.18673V10.0884L1.53789 12.2956V13.5442H13.3098V12.2956L11.8383 10.0884V6.18673C11.8383 5.01594 11.3732 3.8931 10.5453 3.06523C9.71746 2.23736 8.59463 1.77227 7.42384 1.77227Z",
    fill: "#4E5AC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationbell);
export default __webpack_public_path__ + "static/media/notificationbell.c78137e78c4072113f350bd93ce3dca5.svg";
export { ForwardRef as ReactComponent };